import React, { useState } from 'react';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { blogPosts } from '../mockData';
import BlogArticle from './BlogArticle';

const Blog = () => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [isArticleOpen, setIsArticleOpen] = useState(false);

  const handleArticleClick = (title) => {
    setSelectedArticle(title);
    setIsArticleOpen(true);
  };

  const blogImages = [
    'https://images.pexels.com/photos/32396570/pexels-photo-32396570.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    'https://images.unsplash.com/photo-1694903089438-bf28d4697d9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxBSSUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzc1MzkzOTAwfDA&ixlib=rb-4.1.0&q=85',
    'https://images.unsplash.com/photo-1716436329836-208bea5a55e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxBSSUyMGF1dG9tYXRpb258ZW58MHx8fHwxNzc1MzkzOTAwfDA&ixlib=rb-4.1.0&q=85'
  ];

  return (
    <>
      <section id="blog" className="bg-slate-950 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Latest{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Insights
            </span>
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Expert analysis and guides to help you succeed in AI trading
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {blogPosts.map((post, index) => (
            <article
              key={index}
              className="group bg-gradient-to-br from-slate-900/50 to-slate-900/30 backdrop-blur-sm border border-slate-800/50 rounded-xl overflow-hidden hover:border-cyan-500/50 transition-all duration-300 hover:transform hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={blogImages[index]}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent"></div>
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-gradient-to-r from-cyan-500 to-blue-600 backdrop-blur-sm text-white text-xs font-semibold rounded-full">
                    {post.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-4 text-sm text-slate-500 mb-3">
                  <div className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    <span>{post.date}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    <span>{post.readTime}</span>
                  </div>
                </div>

                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors duration-300">
                  {post.title}
                </h3>

                <p className="text-slate-400 text-sm mb-4 leading-relaxed">
                  {post.excerpt}
                </p>

                <button 
                  onClick={() => handleArticleClick(post.title)}
                  className="flex items-center gap-2 text-cyan-400 font-semibold text-sm group-hover:gap-3 transition-all duration-300"
                >
                  <span>Read More</span>
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="px-8 py-4 bg-slate-800/50 hover:bg-slate-800 text-white font-semibold rounded-lg border border-slate-700/50 hover:border-cyan-500/50 transition-all duration-300">
            View All Articles
          </button>
        </div>
      </div>
    </section>
    
    <BlogArticle 
      isOpen={isArticleOpen}
      onClose={() => setIsArticleOpen(false)}
      articleTitle={selectedArticle}
    />
  </>
  );
};

export default Blog;
